const initialize = () => {
    const InflatorComps = require('utils/framework/InflateComponents').default;
    const store = require('store/Store');
    const ProductActions = require('actions/ProductActions');
    const { Application } = require('utils/framework').default;
    const { ProductInfo, EventType, ProductInfoLoaded, HydrationFinished } = require('constants/events');

    /* ProductInfo Service */
    Application.events.onLastLoadEvent(window, [HydrationFinished, ProductInfoLoaded], () => {
        const productInfo = InflatorComps.services.ProductInfo;
        const productData = productInfo.data;

        store.dispatch(ProductActions.updateCurrentUserSpecificProduct({ ...productData }));

        Application.events.dispatchServiceEvent(ProductInfo, EventType.Ready);
        Application.events.dispatchServiceEvent(ProductInfo, EventType.ServiceCtrlrsApplied, true);
    });

    return null;
};

module.exports = {
    initialize
};
